import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const CrossPromoContent = styled.div`
  display: block;
  height: ${(props) => (props.height ? props.height : undefined)};
  margin: 0 auto 30px auto;
  padding-bottom: ${(props) => (props.height ? '50px' : undefined)};
  padding-top: ${(props) => (props.height ? '50px' : undefined)};
  text-align: center;
  max-width: 350px;
  width: 100%;

  ${(props) =>
    props.border && {
      backgroundColor: '#FFFFFF',
      borderRadius: '3px',
      boxShadow: '0 0 4px 0 rgba(167,166,171,0.6)',
    }}

  &:last-child {
    margin-bottom: 0;
  }

  @media ${breakpoints.small} {
    width: 370px;
  }

  @media ${breakpoints.large} {
    display: inline-block;
    width: 300px;
  }

  @media ${breakpoints.extraLarge} {
    width: 370px;
  }
`;
